module.exports = __webpack_public_path__ + "img/PEUGEOT_5008.bd425487.jpg";